<script>
import ContratoService from '../../../../domain/contrato/services/contrato'
import service from '../../../../domain/usuarios/services'

const {list: listContratos} = ContratoService

export default {
  name: 'UsuarioContratos',
  props: {
    contratosUsuario: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data () {
    return {
      contratos: [],
      contratoOptions: [
        {label: 'Habilitado', value: true, class: 'btn-default'},
        {label: 'Desabilitado', value: false, class: 'btn-default'}
      ]
    }
  },
  mounted () {
    this.load(10000, 1, '')
  },
  methods: {
    load (limit, page, filtros) {
      this.data = null
      this.isLoading = true
      listContratos(limit, page, filtros)
        .then((response) => {
          this.isLoading = false
          this.contratos = (response.data.result || []).map(contrato => {
            contrato.ativado = this.contratosUsuario.some(p => p.contrato.id === contrato.id)
            return contrato
          })

          // TODO: paginação?
          /* this.pagination.atualPage = response.contratos.offset
          this.pagination.totalPages = response.contratos.totalPages
          this.pagination.totalItems = response.contratos.total */
        })
        .catch((response) => {
          this.isLoading = false
          console.log(response)
        })
    },
    relacionarUsuarioContrato (index) {
      const contrato = this.contratos[index]
      const tmp = {true: 'habilitar', false: 'remover'}
      const confirmado = confirm(`Confirmar ${tmp[contrato.ativado]} pátio "${contrato.nome}" para este usuário?`)
      if (!confirmado) {
        contrato.ativado = !contrato.ativado
        return
      }
      service.relacionarContrato(this.$route.params.id, contrato.id, contrato.ativado)
        .then((response) => {
          if (contrato.ativado) {
            this.contratosUsuario.push({contrato})
          } else {
            const index = this.contratosUsuario.findIndex(p => p.contrato.id === contrato.id)
            this.contratosUsuario.splice(index, 1)
          }
          console.log(response)
        })
        .catch((response) => {
          window.alert(`Não foi possível adicionar o pátio "${contrato.nome}", algum problema ocorreu, tente novamente.`)
          contrato.ativado = !contrato.ativado
          console.log(response)
        })
    }
  }
}
</script>

<template>
  <!--  <div class="wrapper" v-if="contratos.length">-->
    <div class="panel panel-default">
      <div class="table-responsive" style="overflow-y: auto; overflow-x: unset">
        <table class="table table-hover table-striped b-t b-light">
          <thead>
          <tr>
            <th>Nome</th>
            <th>Ação</th>
          </tr>
          </thead>
          <tbody>
          <!-- FAKE -->
          <tr v-if="!contratos.length" v-for="i in [1,2,3]">
            <td role="button" tabindex="0">
              <u-fake-loader width="40%" class="m-t"></u-fake-loader>
            </td>
            <td role="button" tabindex="0">
              <a class="text-cap custom-link ">
                <u-fake-loader width="100%" class="m-t"></u-fake-loader>
              </a>
            </td>
          </tr>
          <tr v-for="(contrato, index) in contratos">
            <td role="button" tabindex="0"> {{contrato.nome}}</td>
            <td role="button" tabindex="0">
              <u-button-group
                @change="relacionarUsuarioContrato(index)"
                class="hidden-print"
                v-model="contrato.ativado"
                :options="contratoOptions"
              >
              </u-button-group>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// UsuarioContratos.vue?7d37b39a